/**
 * FAQPage structured data (https://schema.org/FAQPage) built from the rendered FAQ items.
 * Answers keep their HTML, as Google allows basic tags (p, ul, ol, li, a, strong, em, br) in Answer text.
 *
 * @param {Array} [items] - FAQ items; each item holds question and answer.
 * @returns {JSX.Element|null}
 */
export default function FAQSchema({ items = [] }) {
  const entities = items
    .filter((item) => typeof item?.question === "string" && typeof item?.answer === "string" && !!item.answer)
    .map((item) => ({
      "@type": "Question",
      name: item.question.trim(),
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer.trim(),
      },
    }));

  if (!entities.length) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: entities,
  };

  // Escape "<" so answer HTML can never close the script tag early.
  const json = JSON.stringify(schema).replace(/</g, "\\u003c");

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
}
